import { render } from "./FooterMain.component.vue?vue&type=template&id=9a6223ec&scoped=true"
const script = {}

import "./FooterMain.component.vue?vue&type=style&index=0&id=9a6223ec&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/MONICAS/FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6223ec"]])

export default __exports__